export default "__VITE_ASSET__6a4e8d54__"